import { ReactElement } from 'react';
import { AudioOutlined } from '@ant-design/icons';
import { Mic } from 'lucide-react';
import { Upload } from 'antd';
import {
  Section,
  SectionInner,
  MicrophoneIcon,
  Title,
  Description,
  FormatInfo,
  UploadButton,
} from './FileUpload.style';

interface Props {
  onFileSelect: (file: File | null) => void;
  selectedFile: File | null;
}

const FileUpload = ({ onFileSelect, selectedFile }: Props): ReactElement => {
  return (
    <Section>
      <SectionInner>
        <MicrophoneIcon>
          <Mic size={45} strokeWidth={2.5} />
        </MicrophoneIcon>
        <Title>録音ファイルをアップロード</Title>
        <Description>
          音声ファイルを選択してアップロードしてください。AIが自動で文字起こしと
          <br />
          コンプライアンスチェックを実行します。
        </Description>
        <Upload
          accept='.m4a,audio/mp4,audio/x-m4a'
          beforeUpload={file => {
            onFileSelect(file);
            return false;
          }}
          onRemove={() => {
            onFileSelect(null);
          }}
          maxCount={1}
          showUploadList={false}
        >
          <UploadButton type='primary' icon={<AudioOutlined />}>
            {selectedFile ? selectedFile.name : 'ファイルを選択'}
          </UploadButton>
        </Upload>
        <FormatInfo>対応形式: M4A</FormatInfo>
      </SectionInner>
    </Section>
  );
};

export default FileUpload;
